import PropTypes from 'prop-types';

export default function OutlineTaxes(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            {/* Calculator/document with percentage - represents taxes */}
            <rect
                x="3"
                y="2"
                width="14"
                height="16"
                rx="2"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M7 6h6" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
            <circle cx="7.5" cy="10.5" r="1.5" stroke={color} strokeWidth={strokeWidth} />
            <circle cx="12.5" cy="13.5" r="1.5" stroke={color} strokeWidth={strokeWidth} />
            <path d="M13 10L7 14" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" />
        </svg>
    );
}

OutlineTaxes.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
